import React from 'react';

import SectionTitle from '../SectionTitle';

import classes from './FeaturedEntitySection.module.scss';

const FeaturedEntitySection = ({ title, linkProps, withActions, children, hideViewAll = false, trackingData = {} }) => (
  <div className={classes.root}>
    <SectionTitle
      title={title}
      linkProps={linkProps}
      withActions={withActions}
      hideViewAll={hideViewAll}
      trackingData={trackingData}
    />
    <div className={classes.content}>{children}</div>
  </div>
);

export default FeaturedEntitySection;
